"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function UserBalanceFromJSON(json) {
    return UserBalanceFromJSONTyped(json, false);
}
exports.UserBalanceFromJSON = UserBalanceFromJSON;
function UserBalanceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unsettledCash': !runtime_1.exists(json, 'unsettledCash') ? undefined : json['unsettledCash'],
        'netFundsAvailable': !runtime_1.exists(json, 'netFundsAvailable') ? undefined : json['netFundsAvailable'],
        'actualCash': !runtime_1.exists(json, 'actualCash') ? undefined : json['actualCash'],
        'sodTotalTradeBalance': !runtime_1.exists(json, 'sodTotalTradeBalance') ? undefined : json['sodTotalTradeBalance'],
        'sodNetBalance': !runtime_1.exists(json, 'sodNetBalance') ? undefined : json['sodNetBalance'],
        'sodHouseExcess': !runtime_1.exists(json, 'sodHouseExcess') ? undefined : json['sodHouseExcess'],
        'sodDayBP': !runtime_1.exists(json, 'sodDayBP') ? undefined : json['sodDayBP'],
        'pendingDebitInterest': !runtime_1.exists(json, 'pendingDebitInterest') ? undefined : json['pendingDebitInterest'],
        'settledCash': !runtime_1.exists(json, 'settledCash') ? undefined : json['settledCash'],
        'sodEquity': !runtime_1.exists(json, 'sodEquity') ? undefined : json['sodEquity'],
        'sodMoneyMarketFunds': !runtime_1.exists(json, 'sodMoneyMarketFunds') ? undefined : json['sodMoneyMarketFunds'],
        'actualCashAndMoneyMarket': !runtime_1.exists(json, 'actualCashAndMoneyMarket') ? undefined : json['actualCashAndMoneyMarket'],
        'buyingPower': !runtime_1.exists(json, 'buyingPower') ? undefined : json['buyingPower'],
        'sodOptionsShort': !runtime_1.exists(json, 'sodOptionsShort') ? undefined : json['sodOptionsShort'],
        'fullyPaidUnsettledBalance': !runtime_1.exists(json, 'fullyPaidUnsettledBalance') ? undefined : json['fullyPaidUnsettledBalance'],
        'sodOvernightBP': !runtime_1.exists(json, 'sodOvernightBP') ? undefined : json['sodOvernightBP'],
        'sodCashOnAccount': !runtime_1.exists(json, 'sodCashOnAccount') ? undefined : json['sodCashOnAccount'],
        'sodSma': !runtime_1.exists(json, 'sodSma') ? undefined : json['sodSma'],
        'sodEquityShort': !runtime_1.exists(json, 'sodEquityShort') ? undefined : json['sodEquityShort'],
        'grossFundsAvailable': !runtime_1.exists(json, 'grossFundsAvailable') ? undefined : json['grossFundsAvailable'],
        'currency': !runtime_1.exists(json, 'currency') ? undefined : json['currency'],
        'sodTotalEquity': !runtime_1.exists(json, 'sodTotalEquity') ? undefined : json['sodTotalEquity'],
        'sodMarginBalance': !runtime_1.exists(json, 'sodMarginBalance') ? undefined : json['sodMarginBalance'],
        'cash': !runtime_1.exists(json, 'cash') ? undefined : json['cash'],
        'sodMaintenanceExcess': !runtime_1.exists(json, 'sodMaintenanceExcess') ? undefined : json['sodMaintenanceExcess'],
        'sodEquityMarketValue': !runtime_1.exists(json, 'sodEquityMarketValue') ? undefined : json['sodEquityMarketValue'],
        'sellToOpenCash': !runtime_1.exists(json, 'sellToOpenCash') ? undefined : json['sellToOpenCash'],
        'pendingTransfer': !runtime_1.exists(json, 'pendingTransfer') ? undefined : json['pendingTransfer'],
        'recentDeposit': !runtime_1.exists(json, 'recentDeposit') ? undefined : json['recentDeposit'],
        'sodCash': !runtime_1.exists(json, 'sodCash') ? undefined : json['sodCash'],
        'sodShortBalance': !runtime_1.exists(json, 'sodShortBalance') ? undefined : json['sodShortBalance'],
        'pendingDebitDividend': !runtime_1.exists(json, 'pendingDebitDividend') ? undefined : json['pendingDebitDividend'],
        'sodTaxWitholding': !runtime_1.exists(json, 'sodTaxWitholding') ? undefined : json['sodTaxWitholding'],
        'sodDebitBalance': !runtime_1.exists(json, 'sodDebitBalance') ? undefined : json['sodDebitBalance'],
        'sodAvailable': !runtime_1.exists(json, 'sodAvailable') ? undefined : json['sodAvailable'],
        'sodOptionsLong': !runtime_1.exists(json, 'sodOptionsLong') ? undefined : json['sodOptionsLong'],
        'sodCashEquity': !runtime_1.exists(json, 'sodCashEquity') ? undefined : json['sodCashEquity'],
        'sodCashBalance': !runtime_1.exists(json, 'sodCashBalance') ? undefined : json['sodCashBalance'],
        'sodMarginExcessEquity': !runtime_1.exists(json, 'sodMarginExcessEquity') ? undefined : json['sodMarginExcessEquity'],
        'availableCash': !runtime_1.exists(json, 'availableCash') ? undefined : json['availableCash'],
        'cashOnAccount': !runtime_1.exists(json, 'cashOnAccount') ? undefined : json['cashOnAccount'],
    };
}
exports.UserBalanceFromJSONTyped = UserBalanceFromJSONTyped;
function UserBalanceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'unsettledCash': value.unsettledCash,
        'netFundsAvailable': value.netFundsAvailable,
        'actualCash': value.actualCash,
        'sodTotalTradeBalance': value.sodTotalTradeBalance,
        'sodNetBalance': value.sodNetBalance,
        'sodHouseExcess': value.sodHouseExcess,
        'sodDayBP': value.sodDayBP,
        'pendingDebitInterest': value.pendingDebitInterest,
        'settledCash': value.settledCash,
        'sodEquity': value.sodEquity,
        'sodMoneyMarketFunds': value.sodMoneyMarketFunds,
        'actualCashAndMoneyMarket': value.actualCashAndMoneyMarket,
        'buyingPower': value.buyingPower,
        'sodOptionsShort': value.sodOptionsShort,
        'fullyPaidUnsettledBalance': value.fullyPaidUnsettledBalance,
        'sodOvernightBP': value.sodOvernightBP,
        'sodCashOnAccount': value.sodCashOnAccount,
        'sodSma': value.sodSma,
        'sodEquityShort': value.sodEquityShort,
        'grossFundsAvailable': value.grossFundsAvailable,
        'currency': value.currency,
        'sodTotalEquity': value.sodTotalEquity,
        'sodMarginBalance': value.sodMarginBalance,
        'cash': value.cash,
        'sodMaintenanceExcess': value.sodMaintenanceExcess,
        'sodEquityMarketValue': value.sodEquityMarketValue,
        'sellToOpenCash': value.sellToOpenCash,
        'pendingTransfer': value.pendingTransfer,
        'recentDeposit': value.recentDeposit,
        'sodCash': value.sodCash,
        'sodShortBalance': value.sodShortBalance,
        'pendingDebitDividend': value.pendingDebitDividend,
        'sodTaxWitholding': value.sodTaxWitholding,
        'sodDebitBalance': value.sodDebitBalance,
        'sodAvailable': value.sodAvailable,
        'sodOptionsLong': value.sodOptionsLong,
        'sodCashEquity': value.sodCashEquity,
        'sodCashBalance': value.sodCashBalance,
        'sodMarginExcessEquity': value.sodMarginExcessEquity,
        'availableCash': value.availableCash,
        'cashOnAccount': value.cashOnAccount,
    };
}
exports.UserBalanceToJSON = UserBalanceToJSON;
